import { ChatBotPublicAccessPage } from '@/Workspaces/ChatBot/ChatBotPublicAccessPage'
import { createFileRoute, useParams } from '@tanstack/react-router'
import z from 'zod'


const publicAccessSchema = z.object({
  accessKey: z.string().optional().catch(''),
})

export const Route = createFileRoute('/workspace/$workspaceId/chatBotData/$chatBotDataId/publicChat')({
  component: RouteComponent,
  validateSearch: (search) => publicAccessSchema.parse(search),
})

function RouteComponent() {
  const { workspaceId, chatBotDataId } = useParams({ from: "/workspace/$workspaceId/chatBotData/$chatBotDataId/publicChat" })
  return <ChatBotPublicAccessPage workspaceId={workspaceId} chatBotId={chatBotDataId} />
}
